module.exports = __webpack_public_path__ + "static/img/function6.0dc68b76.png";